import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NotificationFacade } from '@ridango/components';
import { AuthParametersFacade } from '@ridango/components/lib/auth/+state/auth-parameters';

import { RIDANGO_PASSWORD_RECOVERY_STEPS } from '@ridango/core';
import Env from '@ridango/core/env';
import { take, takeUntil } from 'rxjs/operators';
import { BaseComponent } from '@ridango/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    templateUrl: './password-recover-page.component.html',
    styleUrls: ['./password-recover-page.component.scss']
})
export class PasswordRecoverPageComponent extends BaseComponent implements OnInit, OnDestroy {
    steps = RIDANGO_PASSWORD_RECOVERY_STEPS;
    step = 1;
    email = '';
    callback: string;
    allowReset = true;

    constructor(
        @Inject('ENV') public env: Env,
        private route: ActivatedRoute,
        private authParams: AuthParametersFacade,
        private notification: NotificationFacade,
        private translate: TranslateService
    ) {
        super();
    }

    ngOnInit() {
        if (this.env.SIGN_ON_PAGE) {
            this.handleCallbackURL();
        }
    }

    submitEmail(email: string) {
        this.email = email;
    }

    handleComplete(event: number) {
        this.step = event;
    }

    handleCallbackURL() {
        this.authParams.callback$.pipe(take(2)).subscribe((callback) => {
            if (callback) {
                this.callback = callback;
            }
        });
        this.route.queryParams.pipe(takeUntil(this.componentDestroyed$)).subscribe((params) => {
            if (params.callback) {
                this.authParams.setCallback(params.callback);
            }
        });
        if (!this.callback) {
            this.allowReset = false;
            this.notification.error(this.translate.instant('CALLBACK_MISSING'));
        }
    }

    handleBackClicked() {
        window.history.back();
    }
}
